module.exports = __webpack_public_path__ + "static/img/card_2_1.31e24dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/es/card_2_1.png
// module id = GOdL
// module chunks = 0